module.exports = __webpack_public_path__ + "img/aiimg2.89619d46.png";